export default "__VITE_ASSET__b3I3kvTR__"